import { Container, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import Page from 'src/components/molecules/page';
import { IrregularSettingForm } from 'src/components/organisms/reservation-frame/detail/irregular-setting/form';

export const IrregularSettingFrameCreatePage: FC = () => {
  /* 定数宣言 */
  const title = 'イレギェラー設定作成';

  return (
    <Page title={title}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        </Stack>
        <IrregularSettingForm />
      </Container>
    </Page>
  );
};
